/**
 * Hook to fetch and transform recently used agencies for the sidebar navigation.
 */

import { useGetRecentlyUsedAgenciesQuery } from '@saaga/shared/store/agency-endpoints.store'
import { useMemo } from 'react'

import { transformAgencyToNavItem } from './sidebar-agency-mapper.util'
import type { SidebarNavItem } from './sidebar-nav-item.interface'

const PAGE_SIZE = 10

interface UseSidebarRecentlyUsedAgenciesReturn {
  agencyItemList: SidebarNavItem[]
  isLoading: boolean
  isError: boolean
}

export const useSidebarRecentlyUsedAgencies = (): UseSidebarRecentlyUsedAgenciesReturn => {
  const { data, isLoading, isError } = useGetRecentlyUsedAgenciesQuery({
    page: 1,
    pageSize: PAGE_SIZE,
  })

  const agencyItemList = useMemo(() => {
    if (!data?.items) return []
    return data.items.map(transformAgencyToNavItem)
  }, [data?.items])

  return {
    agencyItemList,
    isLoading,
    isError,
  }
}
